import { useLayoutEffect, useState } from 'react'

export function menuPlacement(anchor, height, viewportHeight, viewportTop = 0) {
    const above = Math.max(0, anchor.top - viewportTop - 14)
    const below = Math.max(0, viewportTop + viewportHeight - anchor.bottom - 14)
    const upward = height > below && above > below
    return {
        top: upward ? 'auto' : 'calc(100% + 6px)',
        bottom: upward ? 'calc(100% + 6px)' : 'auto',
        maxHeight: Math.min(height, upward ? above : below),
        overflowY: 'auto',
    }
}

// Re-measure on dialog scrolling and viewport resizing as well as opening.
export default function useActivityMenuPlacement(ref, preferredHeight) {
    const [style, setStyle] = useState({})
    useLayoutEffect(() => {
        const box = ref.current
        const anchor = box?.parentElement
        if (!box || !anchor) return undefined
        const measure = () => {
            const viewport = window.visualViewport
            const naturalHeight = box.scrollHeight + 2
            const height = preferredHeight ? Math.min(preferredHeight, naturalHeight) : naturalHeight
            const next = menuPlacement(anchor.getBoundingClientRect(), height, viewport?.height || window.innerHeight, viewport?.offsetTop || 0)
            setStyle(previous => Object.keys(next).every(key => previous[key] === next[key]) ? previous : next)
        }
        measure()
        const observer = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(measure)
        observer?.observe(box)
        observer?.observe(anchor)
        window.addEventListener('resize', measure)
        window.addEventListener('scroll', measure, true)
        window.visualViewport?.addEventListener('resize', measure)
        window.visualViewport?.addEventListener('scroll', measure)
        return () => {
            observer?.disconnect()
            window.removeEventListener('resize', measure)
            window.removeEventListener('scroll', measure, true)
            window.visualViewport?.removeEventListener('resize', measure)
            window.visualViewport?.removeEventListener('scroll', measure)
        }
    }, [ref, preferredHeight])
    return style
}
